<template>
  <h2>Messdienerplan vom {{ new Date(schedule.startDate).toLocaleDateString() }} bis zum
    {{ new Date(schedule.endDate).toLocaleDateString() }}</h2>
  <div class="fst-italic">{{ schedule.annotation }}</div>
  <router-link :to="{name: 'Plan', params: {id: this.scheduleId}}" class="link-secondary"><em
      class="align-middle material-icons">arrow_back_ios</em> Zurück zum Plan
  </router-link>
  <table class="table table-light align-middle table-sm table-bordered">
    <caption>Statistik Zusammenfassung</caption>
    <thead>
    <tr>
      <th scope="col"></th>
      <th class="text-center" colspan="5" scope="colgroup">Anzahl Dienste</th>
      <th class="text-center" colspan="5" scope="colgroup">Abstand Dienste</th>
    </tr>
    <tr>
      <th class="text-center" scope="col"></th>
      <th class="text-center" scope="col">Min</th>
      <th class="text-center" scope="col">Max</th>
      <th class="text-center" scope="col">Durchschnitt</th>
      <th class="text-center" scope="col">Median</th>
      <th class="text-center" scope="col">Var.-Koeff.</th>
      <th class="text-center" scope="col">Min</th>
      <th class="text-center" scope="col">Median</th>
      <th class="text-center" scope="col">Max</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th scope="row">Leiter</th>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'min', a => a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'min', a => a.leader) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'max', a => a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'max', a => a.leader) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'avg', a => a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'avg', a => a.leader).toFixed(2) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'median', a => a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'median', a => a.leader) }}
      </td>
      <td :style="{backgroundColor: this.generateColorValue(statisticForCol('shift_count', 'var_coeff', a => a.leader), 0, 0.5) }"
          class="text-center">
        {{ (100 * statisticForCol('shift_count', 'var_coeff', a => a.leader)).toFixed(2) }} %
      </td>
      <td class="text-center">{{ statisticForCol('distances_min', 'min', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_min', 'median', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_min', 'max', a => a.leader) }}
        ({{ (100 * statisticForCol('distances_min', 'var_coeff', a => a.leader)).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_median', 'min', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_median', 'median', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_median', 'max', a => a.leader) }}
        ({{ (100 * statisticForCol('distances_median', 'var_coeff', a => a.leader)).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_max', 'min', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_max', 'median', a => a.leader) }} &rarr;
        {{ statisticForCol('distances_max', 'max', a => a.leader) }}
        ({{ (100 * statisticForCol('distances_max', 'var_coeff', a => a.leader)).toFixed(2) }} %)
      </td>
    </tr>
    <tr>
      <th scope="row">Kinder</th>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'min', a => !a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'min', a => !a.leader) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'max', a => !a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'max', a => !a.leader) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'median', a => !a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'avg', a => !a.leader).toFixed(2) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'median', a => !a.leader),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'median', a => !a.leader) }}
      </td>
      <td :style="{backgroundColor: this.generateColorValue(statisticForCol('shift_count', 'var_coeff', a => !a.leader), 0, 0.5) }"
          class="text-center">
        {{ (100 * statisticForCol('shift_count', 'var_coeff', a => !a.leader)).toFixed(2) }} %
      </td>
      <td class="text-center">{{ statisticForCol('distances_min', 'min', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_min', 'median', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_min', 'max', a => !a.leader) }}
        ({{ (100 * statisticForCol('distances_min', 'var_coeff', a => !a.leader)).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_median', 'min', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_median', 'median', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_median', 'max', a => !a.leader) }}
        ({{ (100 * statisticForCol('distances_median', 'var_coeff', a => !a.leader)).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_max', 'min', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_max', 'median', a => !a.leader) }} &rarr;
        {{ statisticForCol('distances_max', 'max', a => !a.leader) }}
        ({{ (100 * statisticForCol('distances_max', 'var_coeff', a => !a.leader)).toFixed(2) }} %)
      </td>
    </tr>
    <tr>
      <th scope="row">Gesamt</th>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'min'),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'min') }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'max'),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'max') }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'median'),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'avg').toFixed(2) }}
      </td>
      <td :style="{backgroundColor: this.colorForCell('shift_count', statisticForCol('shift_count', 'median'),false)}"
          class="text-center">
        {{ statisticForCol('shift_count', 'median') }}
      </td>
      <td :style="{backgroundColor: this.generateColorValue(statisticForCol('shift_count', 'var_coeff'), 0, 0.5) }"
          class="text-center">
        {{ (100 * statisticForCol('shift_count', 'var_coeff')).toFixed(2) }} %
      </td>
      <td class="text-center">{{ statisticForCol('distances_min', 'min') }} &rarr;
        {{ statisticForCol('distances_min', 'median') }} &rarr; {{ statisticForCol('distances_min', 'max') }}
        ({{ (100 * statisticForCol('distances_min', 'var_coeff')).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_median', 'min') }} &rarr;
        {{ statisticForCol('distances_median', 'median') }} &rarr; {{ statisticForCol('distances_median', 'max') }}
        ({{ (100 * statisticForCol('distances_median', 'var_coeff')).toFixed(2) }} %)
      </td>
      <td class="text-center">{{ statisticForCol('distances_max', 'min') }} &rarr;
        {{ statisticForCol('distances_max', 'median') }} &rarr; {{ statisticForCol('distances_max', 'max') }}
        ({{ (100 * statisticForCol('distances_max', 'var_coeff')).toFixed(2) }} %)
      </td>
    </tr>
    </tbody>
  </table>
  <div class="table-responsive">
    <table class="table table-light align-middle table-sm">
      <caption>Statistik</caption>
      <thead>
      <tr>
        <th scope="col" @click="sort('lastname')" v-html="titleWithSortingIndicator('Nachname', 'lastname')"></th>
        <th scope="col" @click="sort('firstname')" v-html="titleWithSortingIndicator('Vorname', 'firstname')"></th>
        <th scope="col" @click="sort('leader')" v-html="titleWithSortingIndicator('Leiter', 'leader')"></th>
        <th scope="col" @click="sort('shift_count')"
            v-html="titleWithSortingIndicator('Anzahl Dienste', 'shift_count')"></th>
        <th scope="col" @click="sort('distances_min')"
            v-html="titleWithSortingIndicator('Min. Abstand', 'distances_min')"></th>
        <th scope="col" @click="sort('distances_median')"
            v-html="titleWithSortingIndicator('Median Abstand','distances_median')"></th>
        <th scope="col" @click="sort('distances_max')"
            v-html="titleWithSortingIndicator('Max. Abstand', 'distances_max')"></th>
        <th scope="col" @click="sort('distances_var_coeff')"
            v-html="titleWithSortingIndicator('Var.-koeffizient Abstand', 'distances_var_coeff')"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="altarServer in sortedAltarServers" :key="altarServer.id">
        <td>{{ altarServer.lastname }}</td>
        <td>{{ altarServer.firstname }}</td>
        <td><input :checked="altarServer.leader" disabled type="checkbox"></td>
        <td :style="{backgroundColor: this.colorForCell('shift_count', altarServer.shift_count,false)}">
          {{ altarServer.shift_count }}
        </td>
        <td>
          <span v-if="altarServer.distances_min !== -1"
                :style="{color: this.colorForCell('distances_min', altarServer.distances_min,true)}">{{
              altarServer.distances_min
            }}</span>
          <em v-else class="align-middle material-icons">remove</em>
        </td>
        <td>
          <span v-if="altarServer.distances_median !== -1"
                :style="{color: this.colorForCell('distances_median', altarServer.distances_median,true)}">{{
              altarServer.distances_median
            }}</span>
          <em v-else class="align-middle material-icons">remove</em>
        </td>
        <td>
          <span v-if="altarServer.distances_max !== -1"
                :style="{color: this.colorForCell('distances_max', altarServer.distances_max,true)}">{{
              altarServer.distances_max
            }}</span>
          <em v-else class="align-middle material-icons">remove</em>
        </td>
        <td>
          <span v-if="altarServer.distances_var_coeff !== -1"
                :style="{color: this.colorForCell('distances_var_coeff', altarServer.distances_var_coeff,false) }">{{
              (100 * altarServer.distances_var_coeff).toFixed(2)
            }} %</span>
          <em v-else class="align-middle material-icons">remove</em>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {useAltarServerStore} from "@/stores/altarServer";
import {useScheduleStore} from "@/stores/schedule";

export default {
  name: "ScheduleStatistics",
  data: function () {
    return {
      schedule: {},
      statistics: {},
      currentSort: [
        {col: 'firstname', sortDir: 'asc'},
        {col: 'lastname', sortDir: 'asc'},
        {col: 'leader', sortDir: 'desc'},
      ],
      scheduleId: Number(this.$route.params.id),
    }
  },
  methods: {
    async getStatistics() {
      try {
        const response = await this.axios.get(`/plaene/${this.$route.params.id}/statistik/`);
        this.statistics = response.data
      } catch (e) {
        console.log(e);
      }
    },
    sort(col) {
      let el = this.currentSort.find(a => a.col === col)
      if (el) {
        if (el.sortDir === 'asc')
          el.sortDir = 'desc';
        else if (el.sortDir === 'desc')
          this.currentSort.splice(this.currentSort.indexOf(el), 1);
      } else {
        this.currentSort.push({'col': col, 'sortDir': 'asc'});
      }
    },
    titleWithSortingIndicator(title, col) {
      let res = `${title}`;
      let el = this.currentSort.find(a => a.col === col);
      if (el) {
        let dir = el.sortDir === 'asc' ? 'up' : 'down';
        res += ` <em class="align-middle material-icons">arrow_drop_${dir}</em><sub>${this.currentSort.length - this.currentSort.indexOf(el)}.</sub>`;
      }
      return res;
    },
    statisticForCol(colum, operation, filter = () => true) {
      let values = this.sortedAltarServers.filter(filter).map(a => a[colum]);
      switch (operation) {
        case 'min':
          return Math.min(...values);
        case 'max':
          return Math.max(...values);
        case 'avg':
          return values.reduce((a, b) => a + b, 0) / values.length;
        case 'median': {
          values = values.sort((a, b) => a - b); // Sort!!!
          let mid = Math.floor(values.length / 2);
          return values.length % 2 !== 0 ? values[mid] : (values[mid - 1] + values[mid]) / 2;
        }
        case 'var_coeff': {
          let avg = values.reduce((a, b) => a + b, 0) / values.length;
          let stdev = Math.sqrt(1 / (values.length - 1) * values.reduce((a, b) => a + Math.pow(b - avg, 2), 0));
          return stdev / avg;
        }
      }
    },
    generateColorValue(value, min, max, reverse) {
      let relativeValue = (value - min) / (max - min);
      let h = reverse ? relativeValue * 120 : (1.0 - relativeValue) * 120;
      return `hsl(${h}, 100%, ${50 - 1 / 6 * h}%)`; // Generate hsl string and adopt lightness for greener colors to avoid getting to bright
    },
    colorForCell(column, value, reverse) { // reverse == true means, that high values are considered to be good and vice-versa
      let min = this.statisticForCol(column, 'min', a => a[column] >= 0);
      let max = this.statisticForCol(column, 'max');
      return this.generateColorValue(value, min, max, reverse);
    }
  },
  computed: {
    sortedAltarServers() {
      let res = [];
      if ('altarServers' in this.schedule) {
        for (let id of this.schedule.altarServers) {
          res.push({'id': id, ...this.altarServerStore.getItemById(id), ...this.statistics[id]});
        }
      }
      res = res.filter(a => a.active); // Filter out inactive altar servers
      for (let col of this.currentSort) {
        res.sort((a, b) => {
          let modifier = col.sortDir === 'asc' ? 1 : -1;
          if (a[col.col] < b[col.col]) return -1 * modifier;
          if (a[col.col] > b[col.col]) return modifier;
          return 0;
        })
      }
      return res;
    },
  },
  created() {
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
    if (!this.scheduleStore.loadedData)
      this.scheduleStore.getData();

    // Load schedule from schedule store
    this.schedule = this.scheduleStore.getItemById(this.scheduleId);

    // Reload schedule when some schedule changed
    this.scheduleStore.$subscribe(() => {
      this.schedule = this.scheduleStore.getItemById(this.scheduleId);
    })

    this.getStatistics();
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    const scheduleStore = useScheduleStore();
    return {altarServerStore, scheduleStore};
  }
}
</script>